export default {"src":"/_next/static/media/paper-plane-send-icon.44696801.svg","height":22,"width":19,"blurWidth":0,"blurHeight":0};